// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="./index.d.ts" />
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import packageJson from 'tv/package.json';
import { v4 as uuid } from 'uuid';
import { API_URLS } from '../../../constants/apiConstants';
import { BAND_TYPE } from '../../../constants/bandConstants';
import { CACHE_KEY } from '../../../constants/commonConstants';
import convertImageUrl from '../../proxy-util/convertImageUrl';
import getPosterUrl from '../../proxy-util/getPosterUrl';
import getThumbnailUrl from '../../proxy-util/getThumbnailUrl';
import TvingLogModule from '../../tving-log-module/TvingLogModule';
import { DeviceModelName, PlatformName } from '../types';
var TIZEN_SERVICE_ID_MAP = {
    PRODUCTION: 'HLoFAbhj6Q.service',
    QA: 'HLoFAbhj6Q.service',
    QC: 'HLoFAbhj6Q.service',
    DEV: 'HLoFAbhj6Q.service',
};
var TizenDeviceManager = /** @class */ (function () {
    function TizenDeviceManager() {
        this.tizenDeviceInfo = {};
        this.logger = TvingLogModule;
        this.tizenDeviceInfo.deviceModel = DeviceModelName.tizen;
        this.tizenDeviceInfo.resolutionWidth = 1920;
        this.tizenDeviceInfo.resolutionHeight = 1080;
        this.tizenDeviceInfo.platformId = PlatformName.tizen;
    }
    TizenDeviceManager.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var deviceUuid, osVersion, isSupportedUhd8k, deviceModel, modelCode, resolutionWidth, resolutionHeight;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.info('[TizenDeviceManager.init()]');
                        deviceUuid = localStorage.getItem(CACHE_KEY.uuid);
                        if (deviceUuid) {
                            this.tizenDeviceInfo.uuid = deviceUuid;
                        }
                        else {
                            this.tizenDeviceInfo.uuid = uuid();
                            localStorage.setItem(CACHE_KEY.uuid, this.tizenDeviceInfo.uuid);
                        }
                        osVersion = localStorage.getItem(CACHE_KEY.DEVICE_OS_VERSION);
                        if (osVersion) {
                            this.tizenDeviceInfo.osVersion = osVersion;
                        }
                        else {
                            this.tizenDeviceInfo.osVersion = tizen.systeminfo.getCapabilities().platformVersion;
                            localStorage.setItem(CACHE_KEY.DEVICE_OS_VERSION, this.tizenDeviceInfo.osVersion);
                        }
                        // APP VERSION
                        try {
                            this.tizenDeviceInfo.appVersion = tizen.package.getPackageInfo().version;
                        }
                        catch (e) {
                            this.logger.error('get app version error', e);
                            this.tizenDeviceInfo.appVersion = '4.0.0';
                        }
                        isSupportedUhd8k = localStorage.getItem(CACHE_KEY.DEVICE_UHD_SUPPORTED);
                        if (isSupportedUhd8k) {
                            this.tizenDeviceInfo.isSupportedUhd8k = isSupportedUhd8k === 'true';
                        }
                        else {
                            this.tizenDeviceInfo.isSupportedUhd8k = webapis.productinfo.isUdPanelSupported();
                            localStorage.setItem(CACHE_KEY.DEVICE_UHD_SUPPORTED, this.tizenDeviceInfo.isSupportedUhd8k.toString());
                        }
                        deviceModel = localStorage.getItem(CACHE_KEY.DEVICE_MODEL);
                        if (deviceModel) {
                            this.tizenDeviceInfo.deviceModel = deviceModel;
                        }
                        else {
                            modelCode = webapis.productinfo.getModelCode();
                            if (modelCode) {
                                this.tizenDeviceInfo.deviceModel = modelCode.slice(0, 20);
                                localStorage.setItem(CACHE_KEY.DEVICE_MODEL, this.tizenDeviceInfo.deviceModel);
                            }
                        }
                        resolutionWidth = localStorage.getItem(CACHE_KEY.DEVICE_RESOLUTION_WIDTH);
                        resolutionHeight = localStorage.getItem(CACHE_KEY.DEVICE_RESOLUTION_HEIGHT);
                        if (!(resolutionWidth && resolutionHeight)) return [3 /*break*/, 1];
                        this.tizenDeviceInfo.resolutionWidth = Number(resolutionWidth);
                        this.tizenDeviceInfo.resolutionHeight = Number(resolutionHeight);
                        return [3 /*break*/, 3];
                    case 1: 
                    // TODO: timeout by [Promise.race]
                    return [4 /*yield*/, new Promise(function (resolve) {
                            tizen.systeminfo.getPropertyValue('DISPLAY', function (display) {
                                var resolutionWidth = display.resolutionWidth, resolutionHeight = display.resolutionHeight;
                                if (resolutionWidth && resolutionHeight && resolutionWidth > 1 && resolutionHeight > 1) {
                                    _this.tizenDeviceInfo.resolutionWidth = resolutionWidth;
                                    _this.tizenDeviceInfo.resolutionHeight = resolutionHeight;
                                    localStorage.setItem(CACHE_KEY.DEVICE_RESOLUTION_WIDTH, _this.tizenDeviceInfo.resolutionWidth.toString());
                                    localStorage.setItem(CACHE_KEY.DEVICE_RESOLUTION_HEIGHT, _this.tizenDeviceInfo.resolutionHeight.toString());
                                }
                                resolve();
                            }, function (e) {
                                _this.logger.error('get resolution error', e);
                                resolve();
                            });
                        })];
                    case 2:
                        // TODO: timeout by [Promise.race]
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        TizenDeviceManager.registerKey();
                        // 삼성 제조사 디버깅 용 임시 console.log 추가 부
                        try {
                            // eslint-disable-next-line no-console
                            console.log('[APP VERSION_WEB VERSION]', "".concat(this.tizenDeviceInfo.appVersion || '4.0.X', "_").concat(packageJson.version));
                        }
                        catch (_b) {
                            // DO NOTHING
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    TizenDeviceManager.registerKey = function () {
        if (TizenDeviceManager.isKeyRegistered) {
            return;
        }
        TizenDeviceManager.isKeyRegistered = true;
        var keyCode = {};
        var supportedKeys = tizen.tvinputdevice.getSupportedKeys();
        for (var i = 0; i < supportedKeys.length; i += 1) {
            keyCode[supportedKeys[i].name] = supportedKeys[i].code;
        }
        // registerkey
        if (keyCode.MediaPlayPause) {
            tizen.tvinputdevice.registerKey('MediaPlayPause');
        }
        if (keyCode.MediaPlay) {
            tizen.tvinputdevice.registerKey('MediaPlay');
        }
        if (keyCode.MediaPause) {
            tizen.tvinputdevice.registerKey('MediaPause');
        }
        if (keyCode.MediaStop) {
            tizen.tvinputdevice.registerKey('MediaStop');
        }
        if (keyCode.MediaRewind) {
            tizen.tvinputdevice.registerKey('MediaRewind');
        }
        if (keyCode.MediaFastForward) {
            tizen.tvinputdevice.registerKey('MediaFastForward');
        }
        // 리모컨 숫자 키
        Array.from({ length: 10 }, function (_, i) { return i; }).forEach(function (i) {
            tizen.tvinputdevice.registerKey(i.toString());
        });
    };
    TizenDeviceManager.prototype.deeplink = function (callback) {
        var _this = this;
        this.logger.info('[TizenDeviceManager.deeplink()]');
        var handleDeeplink = function () {
            try {
                var tizenApplication = tizen.application;
                if (tizenApplication) {
                    var requestedAppControl = tizenApplication.getCurrentApplication().getRequestedAppControl();
                    if (requestedAppControl) {
                        var appControlData = requestedAppControl.appControl.data;
                        for (var i = 0; i < appControlData.length; i += 1) {
                            if (appControlData[i].key === 'PAYLOAD') {
                                // 규격 예시: {\"values\":\"{\\\"assetId\\\":\\\"P001537909\\\",\\\"type\\\":\\\"program\\\"}\"}
                                var actionData = JSON.parse(appControlData[i].value[0]).values; // Do something with this "actionData"
                                var data = JSON.parse(actionData);
                                callback(data.assetId);
                                break;
                            }
                        }
                    }
                    else {
                        _this.logger.warn('no req app control');
                    }
                }
            }
            catch (e) {
                _this.logger.error('deeplink error', e);
            }
        };
        handleDeeplink();
        window.addEventListener('appcontrol', handleDeeplink);
    };
    TizenDeviceManager.prototype.generateTwoDepthData = function (popularPrograms, lastEpisodes) {
        var _this = this;
        var data = {
            sections: [],
        };
        if (popularPrograms && popularPrograms.length > 0) {
            data.sections.push({
                title: '인기 프로그램',
                tiles: popularPrograms
                    .map(function (vodContent) {
                    var _a;
                    return {
                        image_url: convertImageUrl(getPosterUrl(BAND_TYPE.PORT, API_URLS.EPISODES, vodContent, false), _this.tizenDeviceInfo.isSupportedUhd8k ? 366 : 200).replace('F_webp,', ''),
                        image_ratio: '2by3',
                        action_data: JSON.stringify({
                            assetId: (_a = vodContent.program) === null || _a === void 0 ? void 0 : _a.code,
                            type: 'program',
                        }),
                        is_playable: true,
                    };
                })
                    .slice(0, Math.min(popularPrograms.length, 20)),
            });
        }
        if (lastEpisodes && lastEpisodes.length > 0) {
            data.sections.push({
                title: '내가 본 프로그램',
                tiles: lastEpisodes
                    .map(function (myLastsResult) {
                    var _a;
                    return {
                        image_url: convertImageUrl(getThumbnailUrl(BAND_TYPE.EPI, API_URLS.MY_LASTS_TV, myLastsResult), _this.tizenDeviceInfo.isSupportedUhd8k ? 977 : 533).replace('F_webp,', ''),
                        image_ratio: '16by9',
                        action_data: JSON.stringify({
                            assetId: (_a = myLastsResult.content.episode) === null || _a === void 0 ? void 0 : _a.code,
                            type: 'episode',
                        }),
                        is_playable: true,
                    };
                })
                    .slice(0, Math.min(lastEpisodes.length, 20)),
            });
        }
        else {
            data.sections.push({
                title: '내가 본 프로그램',
                tiles: [],
            });
        }
        return JSON.stringify(data);
    };
    TizenDeviceManager.prototype.twoDepth = function (data) {
        var _this = this;
        this.logger.info('[TizenDeviceManager.twoDepth()]');
        if (!tizen) {
            this.logger.warn('tizen is not defined');
            return;
        }
        var serviceId = TIZEN_SERVICE_ID_MAP[process.env.REACT_APP_RELEASE] || TIZEN_SERVICE_ID_MAP.PRODUCTION;
        // this.logger.info('[TizenDeviceManager.twoDepth()]', 'serviceId', serviceId, 'data', data);
        tizen.application.launchAppControl(new tizen.ApplicationControl('http://tizen.org/appcontrol/operation/pick', null, 'image/jpeg', null, [
            new tizen.ApplicationControlData('caller', ['ForegroundApp']),
            new tizen.ApplicationControlData('preview', [data]),
        ]), serviceId, function () {
            _this.logger.debug('launchApplication success');
        }, function (err_) {
            _this.logger.debug('launchApplication failed', err_);
        });
    };
    TizenDeviceManager.prototype.exit = function () {
        this.logger.info('[TizenDeviceManager.exit()]');
        tizen.application.getCurrentApplication().exit();
    };
    TizenDeviceManager.prototype.getDeviceInfo = function () {
        this.logger.info('[TizenDeviceManager.getDeviceInfo()]');
        var _a = this.tizenDeviceInfo, platformId = _a.platformId, appVersion = _a.appVersion, deviceModel = _a.deviceModel, resolutionWidth = _a.resolutionWidth, resolutionHeight = _a.resolutionHeight, uuid = _a.uuid, isSupportedUhd8k = _a.isSupportedUhd8k, osVersion = _a.osVersion;
        return {
            platformOs: "".concat(platformId, " ").concat(osVersion),
            appVersion: appVersion,
            appWebVersion: "".concat(appVersion || '4.0.0', "_").concat(packageJson.version),
            deviceModel: deviceModel,
            resolutionWidth: resolutionWidth,
            resolutionHeight: resolutionHeight,
            uuid: uuid,
            isUhd: isSupportedUhd8k,
            osVersion: osVersion,
        };
    };
    TizenDeviceManager.isKeyRegistered = false;
    return TizenDeviceManager;
}());
export default TizenDeviceManager;
